import { ServiceException } from '@inter-ikea-kompis/exceptions';
/**
 * Utilities related to BitBox.
 */
export default class BitBoxUtility {
    static async readIframeContext(iframe) {
        return await new Promise((resolve, reject) => {
            const timeout = setTimeout(() => {
                window.removeEventListener('message', messageListener);
                reject(new ServiceException('No response from Bitbox iframe script'));
            }, 1000);
            const messageListener = (event) => {
                let parsedData;
                try {
                    parsedData = JSON.parse(event.data);
                }
                catch (error) {
                    return;
                }
                if (parsedData.action === 'set_context') {
                    window.removeEventListener('message', messageListener);
                    clearTimeout(timeout);
                    resolve(parsedData.value);
                }
            };
            window.addEventListener('message', messageListener);
            iframe.contentWindow?.postMessage(JSON.stringify({ action: 'get_context' }), '*');
        });
    }
}
//# sourceMappingURL=BitBoxUtility.js.map